// Build-Variablen. Fehlt eine Pflichtvariable, bricht der Start mit einer klaren Meldung ab —
// statt später mit „Failed to fetch" an einer zufälligen Stelle.

function required(name: string, value: string | undefined): string {
  if (!value) throw new Error(`${name} fehlt (siehe .env.example bzw. node scripts/dev-setup.mjs)`);
  return value;
}

export const env = {
  supabaseUrl: required("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required("VITE_SUPABASE_ANON_KEY", import.meta.env.VITE_SUPABASE_ANON_KEY),
  vapidPublicKey: (import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined) ?? "",
  sentryDsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? "",
  release: (import.meta.env.VITE_SENTRY_RELEASE as string | undefined) ?? "dev",
};
